const getUrlPath = () => {
  const LOCATION = window.location.href;
  return LOCATION.includes('127.0.0.1') || LOCATION.includes('localhost') || LOCATION.includes('dev.')
    ? 'https://api-dev.datasheep.com/'
    : 'https://ww1.datasheep.com/';
};
export default getUrlPath;
